import React from 'react';
import { ASSET_PREFIX } from 'utils/constants';
import SectionTitle from 'components/landing/StrongerVariant/SectionTitle/SectionTitle';
import svStyles from 'components/landing/StrongerVariant/StrongerVariant.module.css';
import s from './AboutUsPopup.module.css';

const AboutUsPopup = ({ onClose }) => {

  return (
    <div className={s.container} id="dimmedBackground" onClick={(e) => e.target.id === 'dimmedBackground' && onClose()}>
      <div id={s.message}>
        <img id={s.closeButton} src={`${ASSET_PREFIX}/images/close_button.svg`} style={{ cursor: 'pointer', width: '15px' }} onClick={onClose} alt='close button - cross'/>

        <SectionTitle>
          <div className={`${svStyles.underline} ${s.heading}`}>About</div>
          <div className={`${svStyles.underline} ${svStyles.outlineText} ${s.heading}`}>us</div>
        </SectionTitle>

        <p className={s.mainText}>
          DAYMADE is a prize platform where players can win incredible holidays, local experiences, home and beauty products, and even your favourite tech. Sign-up now for your free weekly chance to win this amazing travel prize to Barbados (and many more prizes!) worth £2,000. DAYMADE is rated ‘Excellent’ on TrustPilot. Join our community of 20,000 winners and counting.
        </p>
      </div>
    </div>
  );
};

export default AboutUsPopup;
